<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center">
      <Loading />
    </div>
    <div v-else class="dashboard">

      <!-- INICIO BANNER CASHBACK -->
      <!-- <div class="row" >
        <div class="col-12">
          <div class="dashboard__banner-cashback">
            <div class="row align-items-center">
              <div class="col-12 col-md-9 col-lg-10">
                <p>Convide seus amigos e ganhe até <strong>R$ 125,00</strong> para cada indicação!</p>
              </div>
              <div class="col-12 col-md-3 col-lg-2 text-center">
                <router-link to="/investimentos/convidar-amigo" class="btn btn-lg btn-primary" title="Saiba mais">Saiba mais</router-link>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- FINAL BANNER CASHBACK -->
      
      <div class="row align-items-center dashboard__header">
        <div class="col-12 col-lg-7">
          <span>Conta investidor - {{Nome()}}</span>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div class="item">
                <h2>R$ {{this.formatCurrency(this.InvestimentoTotal)}}</h2>
                <small>Investimento total</small>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="item">
                <h2>R$ {{this.formatCurrency(this.RetornoTotal)}}</h2>
                <small>Rendimento total</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5 text-center text-md-right">
          <router-link v-if="false" to="/investimentos/carteira-investimento/adicionar-fundos" title="Adicionar fundos" class="btn btn-primary"><i class="ico-din-4"></i> Adicionar fundos</router-link>
          <router-link  v-if="false" to="" title="Reinvestir fundos" class="btn btn-primary">Resgatar fundos</router-link>
          <!-- <router-link to="" class="btn btn-primary" title="Reinvestir fundos">Reinvestir fundos</router-link> -->
        </div>
      </div>
      <hr class="divider">
      <div class="row">
        <div class="col-12 col-lg-7 dashboard__chart">
          <h1>Meus investimentos <router-link :to="{ name: 'Histórico' }" title="Exibir detalhes">Exibir detalhes</router-link></h1>
           <div v-if="Infos.Operacoes" class="box box_chart" style="margin-top:45px;">
            <bar-chart :data="DataGrafico()"/>

            <ul class="dashboard__chart--scores">
              <li v-for="item in this.DadosLegenda" :key="item">
                <label>{{item.label}} </label>
                <span :style="'background-color:'+ item.color +';'">{{item.percent}}%</span>
              </li>
            </ul>
           </div>
        </div>
        <div class="col-12 col-lg-5">
          <div class="row dashboard__infos">
            <div class="col-12 col-md-6 col-lg-12">
              <div class="box">
                <span>Disponível para saque</span>
                <strong>R$ {{ Saldo == 0 ? this.formatCurrency(Saldo) : this.formatCurrency(Math.floor(Saldo * 100) / 100)}}</strong>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12">
              <div class="box">
                <span>Pendente</span>
                <strong>R$ {{this.formatCurrency(this.Pendente)}}</strong>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12">
              <div class="box">
                <span>A receber</span>
                <strong class="float-right">R$ {{this.formatCurrency(this.Receber)}}</strong>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12">
              <div class="box">
                <span>Estimativa de retorno</span>
                <strong>{{this.formatCurrency(this.PorcentagemRetorno)}}% a.m.</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="divider">
      <ul class="row dashboard__links">
        <li class="col-12 col-md-4 col-lg-4">
          <div class="item">
            <router-link to="/investimentos/carteira-investimento" title="Minha carteira de investimentos">
              <i class="icon icon-wallet"></i>
              Minha carteira de investimentos
            </router-link>
          </div>
        </li>
        <li class="col-12 col-md-4 col-lg-4">
          <div class="item">
            <router-link :to="{ name: 'Oportunidades' }"  title="Ver oportunidades">
              <i class="icon icon-listing"></i>
              Ver oportunidades
            </router-link>
          </div>
        </li>
        <li class="col-12 col-md-4 col-lg-4">
          <div class="item">
            <router-link :to="{ name: 'Histórico' }" title="Histórico de investimentos">
              <i class="icon icon-historic"></i>
              Histórico de investimentos
            </router-link>
          </div>
        </li>
      </ul>
    </div>
    <div>
		<div v-if="loading" class="d-flex justify-content-center align-items-center dashboard">
			<div class="dashboard__complete">
				<div class="row">
					<div class="col-12 text-center">
						<div>
							<h1>Meus investimentos</h1>
							<p v-if="!Investidor()">{{Nome()}}, você ainda não <strong>completou seu cadastro</strong>. Assim que concluir, você poderá escolher as empresas, montar seu portfólio e fazer o seu investimento!</p>
							<router-link v-if="!Investidor()" to="/informacoes-adicionais/investidor" class="btn btn-lg btn-primary" title="Completar cadastro">Completar cadastro</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>


<script>
  /* eslint-disable */

  import WalletService from '../services/api/wallet/index.js';
  import InvestorService from '../services/api/investor/index.js';
  // import MarketingDrip from '../services/api/marketing';

  import Loading from '@/components/SimpleLoader'
  import ApiClient from '../utils/api-client'
  import BarChart from '@/components/charts/BarChartInvestimentos'
  import * as mutationTypes from '@/store/mutation-types.js'

  export default {
    components: { BarChart, Loading },
    ready () {
      this.legendMarkup = this._chart.generateLegend()
    },
     data() {
       return {

        Pendente: 0,
        PorcentagemRetorno:0,
        InvTotal:0,
        Saldo: 0,
        RendimentoTotal:0,
        IdInvestidor:0,
        InvestimentoTotal: 0,
        RetornoTotal: 0,
        Pago: 0,
        Infos:{},
        // renderizou:false,
        loading:true,
        legendMarkup:"",
        DadosLegenda:[],
        Credito: 0,
        Debito: 0,
        TipoUser: '',
        investimentos: '',
        suitability: '',
        investidor: '',
        sexo: '',
        estadoCivil: '',
        perfilSuitability: '',
       }
		 },
		methods: {
      // Requisição para trazer extrato com saldo
      async extratoCarteira() {
        var tempJuros = 0.0, tempPeso = 0.0, count = 0;

        const { data } = await WalletService.GetExtratoSolicitacao();
        // const response = await WalletService.GetTotalInvestido();
        // let totalInvestido = response.data.totalInvestido;

        if (data === undefined) {
          this.loading = false;
          this.RetornoTotal = 0.00;
          this.Saldo = 0.00;
          this.InvestimentoTotal = 0.00;
          this.Pago = 0.00;
          this.PorcentagemRetorno = 0.00;
          return
        } else if (data.Operacoes === undefined) {
          this.loading = false
          this.Infos = data;
          this.Saldo = data.Saldo;
          await this.idInvestidor(data.UserId);
          this.PorcentagemRetorno = (this.RetornoTotal - this.InvestimentoTotal) * 100 / this.InvestimentoTotal;
        } else {
          this.Infos = data;
          this.Saldo = data.Saldo;
          await this.idInvestidor(data.UserId);
          this.PorcentagemRetorno = (this.RetornoTotal - this.InvestimentoTotal) * 100 / this.InvestimentoTotal;
          this.Infos.Operacoes.forEach(async (item)=>{
            if(item.Tipo === "INVESTIMENTO") {

              if(item.Detalhes.Investimento.SolicitacaoId != ""){
                let valorParcela = this.PMT(item.Detalhes.Investimento.RetornoBrutoMensal, item.Detalhes.Investimento.Prazo, item.Detalhes.Investimento.Valor);
                let with2Decimals = (item.Detalhes.Investimento.Prazo * valorParcela * -(item.Valor / item.Detalhes.Investimento.Valor)).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

                this.Infos = Object.assign({},data);
                this.RetornoTotal += parseFloat(with2Decimals);

                tempPeso += item.Detalhes.Investimento.Valor
                tempJuros += item.Detalhes.Investimento.Valor * item.Detalhes.Investimento.RetornoBrutoMensal;
                count++;
              }

              this.InvestimentoTotal += item.Valor * -1;
            }

            if(item.Tipo === "ESTORNO") {

              this.InvestimentoTotal += item.Valor * -1;
              this.RetornoTotal += item.Valor * -1;
              count --;
            }

            if(item.Tipo === "PAGAMENTO") {

              this.Pago += item.Valor;
            }
          });
          
          if(count > 0)
            this.PorcentagemRetorno = (tempJuros / tempPeso);
          else
            this.PorcentagemRetorno = 0;
        }
        
        if (this.User.tipo.length > 1) {
          this.TipoUser = 'Investidor e Tomador'
        } else if (this.User.tipo[0] === 'INV') {
          this.TipoUser = 'Investidor'
        } else {
          this.TipoUser = 'Tomador'
        }

        if(this.InvestimentoTotal === 0) {
          this.RetornoTotal = 0
        }

        // AJUSTE TOTAL INVESTIDO (DATA LAKE: 10/11/2020)

        // this.InvestimentoTotal = totalInvestido

        this.User.hassuitability === true ? this.suitability = 'Verdadeiro' : this.suitability = 'Falso'
        this.User.hasinvestor === true ? this.investidor = 'Verdadeiro' : this.investidor = 'Falso'
        this.User.hasinvestments === true ? this.investimentos = 'Verdadeiro' : this.investimentos = 'Falso'
        if (this.User.investor.Sexo === 1) {
          this.sexo = 'M'
        } else if (this.User.investor.Sexo === 2) {
          this.sexo = 'F'
        }

        if (this.User.investor.EstadoCivil === 1) {
          this.estadoCivil = 'Solteiro (a)'
        } else if (this.User.investor.EstadoCivil === 2) {
          this.estadoCivil = 'Casado (a)'
        } else if (this.User.investor.EstadoCivil === 3) {
          this.estadoCivil = 'Divorciado (a)'
        } else if (this.User.investor.EstadoCivil === 4) {
          this.estadoCivil = 'Viúvo (a)'
        } else if (this.User.investor.EstadoCivil === 5) {
          this.estadoCivil = 'União Estável'
        }

        if (this.User.suitability !== null) {
          this.perfilSuitability = this.User.suitability.Tipo
        } else {
          this.perfilSuitability = ''
        }
      },
    
      async idInvestidor(userId) {

        const { data } = await InvestorService.GetInvestor(userId);

        this.IdInvestidor = data._id;
        this.reservaInvestimentoPendente(data._id);
        return data._id
      },

      async reservaInvestimentoPendente(id) {
        const teste = await InvestorService.GetReservaPendente(id);
        const data = teste.data
        if(data) {
          data.forEach((item) => {
            this.Pendente += item.Valor;
          });
        } else
          this.Pendente = 0;
        this.loading = false;
      },
      Investidor(){

				window.variavel = this
        if(this.User.hasinvestor == undefined)
          return false;

        return this.User.hasinvestor;
      },
      Nome(){
        var nome="", letra = "";
        if(this.User.name == undefined ||this.User.name == null || this.User.name == "")
        {
          nome = this.User.username;
        }else{
          nome = this.User.name;
        }
        nome = nome.trim();

        var primeiroNome = nome.split(" ")[0];

        return primeiroNome[0].toUpperCase() +  primeiroNome.toLowerCase().substring(1);
     },

     formatCurrency(value) {
        if(value != null)
          return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

        return 0;
      },
      DataGrafico() {
        var DadosGrafico = Array();

        DadosGrafico.push({label:"AA",value:0,color:"#C1CF2E", percent: 0});
        DadosGrafico.push({label:"A",value:0,color:"#2DC2BF", percent: 0});
        DadosGrafico.push({label:"B",value:0,color:"#6FC30D", percent: 0});
        DadosGrafico.push({label:"C",value:0,color:"#F04887", percent: 0});
        DadosGrafico.push({label:"D",value:0,color:"#FFB928", percent: 0});
        DadosGrafico.push({label:"E",value:0,color:"#FD615D", percent: 0});
        DadosGrafico.push({label:"HR",value:0,color:"#B61843", percent: 0});
        DadosGrafico.push({label:"Social",value:0,color:"#52B3D9", percent: 0});

        var total = 0;
          
        this.Infos.Operacoes.forEach((item)=>
          {
            if(item.Detalhes.Investimento.SolicitacaoId !== null && item.Tipo === "INVESTIMENTO" && this.InvestimentoTotal > 0){
              
              let cor = "";
              let score = "";

              if(item.Detalhes.Investimento.Score === "" || item.Detalhes.Investimento.Score === undefined){
                score ="Social";
              }else if(item.Detalhes.Investimento.Score === "AA"){
                score ="AA";
              }else if(item.Detalhes.Investimento.Score[0] === "A"){
                score ="A";
              }else if(item.Detalhes.Investimento.Score[0] === "B"){
                score ="B";
              }else if(item.Detalhes.Investimento.Score[0] === "C"){
                score ="C";
              }else if(item.Detalhes.Investimento.Score[0] === "D"){
                score ="D";
              }else if(item.Detalhes.Investimento.Score[0] == "E"){
                score ="E";
              }else if(item.Detalhes.Investimento.Score === "HR"){
                score ="HR";
              }

              var indice  = DadosGrafico.map(function(e) { return e.label; }).indexOf(score);
              DadosGrafico[indice].value += item.Valor * -1;
              total += item.Valor * -1;
            }
          });

          DadosGrafico.forEach((item)=>{
            if(item.value === 0 && total === 0) {
              item.percent = item.value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2});
            } else {
              item.percent =  ((item.value/total)*100).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2});
            }
          })

        this.DadosLegenda = Object.assign({},DadosGrafico);
  
       return DadosGrafico;
      },
      PMT(taxa, prazo, valor) {
        var parcela;

        taxa = taxa / 100;
        parcela = valor * taxa * Math.pow(1+taxa, prazo) / (Math.pow(1+taxa, prazo) - 1);

        return parcela;
      },
      
      //tagueamento GA
      taggingGA() {
        this.$ga.page({
            page: '/investimentos/meus-investimentos',
            title: 'HomeInvestidor',
        })
      },
    },
    computed: {
      User: function() {return this.$store.state.currentUser;},
      Receber(){ 
  
        let receber = this.RetornoTotal - this.Pago;
        if(receber < 0)
          receber = 0;

        return receber; 
      },
    },
    async created() {

      await this.extratoCarteira();

      //tagueamento GA
      await this.taggingGA()
    }

  }
</script>


// WEBPACK FOOTER //
// src/views/HomeInvestor.vue